import React, { useEffect, useState } from 'react';
import { getIndexesFromNodeArray, getNodesArrayFromIndex } from '../../helper/helpersSubModule';
import styles from './PredecessorEditor.module.css';

export function CustomPredecessorEditor({ params, updateRowDHelper }) {
    let {indexString}= getIndexesFromNodeArray(params.value, params)

    const [value, setValue] = useState(indexString);
    const { onValueChange, api, eGridCell, eventKey } = params;

    const inputRef = React.useRef();
    const KEY_BACKSPACE = 'Backspace';

    const getColumnWidth = () => {
        const column = api.getColumn(params.column.colId);
        return column.actualWidth;
    };

    useEffect(() => {
        let startValue;
        if (eventKey === KEY_BACKSPACE) {
            startValue = '';
        } else if (eventKey && eventKey.length === 1) {
            startValue = eventKey;
        } else {
            startValue = value;
        }
        if (startValue == null) {
            startValue = '';
        }
        setValue(startValue)
        onValueChange(startValue)

        if (inputRef.current) {
            inputRef.current.select();
        }
    }, []);

    const handleChange = (event) => {
        const newValue = event.target.value;
        if (newValue) {
            setValue(newValue);
            onValueChange(newValue) 
        }
        else{
            setValue(newValue);
            onValueChange(newValue)  
            
        }
    };

    return (
        <input
            ref={inputRef}
            className={styles.input}
            value={value}
            onChange={handleChange}
            style={{
                minHeight: eGridCell.clientHeight + 4,
                width: getColumnWidth(),
            }}
        />
    );
}

export default CustomPredecessorEditor;
